import { AccessManagementColumn } from '../types';
import { StyledTableRow } from './tableRow';
import { ReactElement } from 'react';
import { UserTranslationKeys } from 'intl/keys';

export const nameColumn: AccessManagementColumn = {
  id: 'name',
  label: UserTranslationKeys.managementName,
  style: { minWidth: '100px' },
};

export function NameRow({ label }: { label: string }): ReactElement {
  return (
    <StyledTableRow key={nameColumn.id}>
      <span>{label}</span>
    </StyledTableRow>
  );
}
